var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoiseSuppressionOff = function SvgNoiseSuppressionOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.062 5.26a.83.83 0 0 0-.229.573v8.334a.833.833 0 0 0 1.667 0v-7.47zm3.105 3.104v8.303a.833.833 0 0 0 1.666 0V10.03zm4.135 4.135a.833.833 0 0 1-.801-.8zm.865-1.53L12.5 9.302v-.969a.833.833 0 0 1 1.667 0zm3.324 3.324-1.658-1.657V5.833a.833.833 0 0 1 1.667 0v8.334a1 1 0 0 1-.01.126m-6.658-6.657L9.167 5.969V3.333a.833.833 0 0 1 1.666 0zm-7.5-.136a.833.833 0 0 0-.833.833v3.334a.833.833 0 0 0 1.667 0V8.333a.833.833 0 0 0-.834-.833",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.915 1.915a.847.847 0 0 1 1.198 0l14.972 14.972a.847.847 0 1 1-1.198 1.198L1.915 3.113a.847.847 0 0 1 0-1.198",
    clipRule: "evenodd"
  })));
};
export default SvgNoiseSuppressionOff;